export const REF_STORAGE_KEY = 'xsocks_ref'
export const REF_COOKIE_NAME = 'xsocks_ref'
export const REF_COOKIE_DOMAIN = '.xsocks.pro'
export const REF_COOKIE_MAX_AGE = 60 * 60 * 24 * 30

export const isValidReferralRef = (ref) => typeof ref === 'string' && /^\d+$/.test(ref)

export const getReferralFromUrl = (search = window.location.search) => {
  try {
    const ref = new URLSearchParams(search).get('ref')
    return isValidReferralRef(ref) ? ref : null
  } catch {
    return null
  }
}

export const getReferralFromCookie = () => {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${REF_COOKIE_NAME}=([^;]*)`))
    const ref = match ? decodeURIComponent(match[1]) : null
    return isValidReferralRef(ref) ? ref : null
  } catch {
    return null
  }
}

export const setReferralCookie = (ref) => {
  if (!isValidReferralRef(ref)) return
  try {
    const host = window.location.hostname
    const isLocalhost = host === 'localhost' || host === '127.0.0.1'
    const domainPart = isLocalhost ? '' : `; domain=${REF_COOKIE_DOMAIN}`
    document.cookie = `${REF_COOKIE_NAME}=${encodeURIComponent(ref)}; path=/${domainPart}; max-age=${REF_COOKIE_MAX_AGE}; SameSite=Lax`
  } catch {
    /* ignore */
  }
}

export const getStoredReferral = () => {
  try {
    const ref = window.localStorage.getItem(REF_STORAGE_KEY)
    if (isValidReferralRef(ref)) return ref
  } catch {
    /* ignore */
  }
  return getReferralFromCookie()
}

export const getActiveReferral = () => getReferralFromUrl() || getStoredReferral()

export const persistReferralFromUrlIfValid = () => {
  try {
    const refFromUrl = getReferralFromUrl()
    if (refFromUrl) {
      window.localStorage.setItem(REF_STORAGE_KEY, refFromUrl)
      setReferralCookie(refFromUrl)
      return
    }
    const refFromCookie = getReferralFromCookie()
    if (refFromCookie) {
      window.localStorage.setItem(REF_STORAGE_KEY, refFromCookie)
    }
  } catch {
    /* ignore */
  }
}
